module.exports = __webpack_public_path__ + "static/media/Hair_3_pink.d35d5c30.svg";